var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"wrapper flex items-center"},[_vm._v("\n  "+_vm._s(_vm.label)+"\n  "),_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.isChecked,"value":_vm.value},on:{"change":_vm.updateInput}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }